<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'AuthenticatedContainer',
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
